import { render } from '@wordpress/element';
import BackendApp from './App/BackendApp';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('dotfw-admin-root');

  if (root) {
    render(
        <BackendApp />,
      	root
    );
  }
});
